// extracted by mini-css-extract-plugin
export default {"box":"InsufficientDataBlock_box__GIa2L","title":"InsufficientDataBlock_title__Ai6a0","link":"InsufficientDataBlock_link__H98Ve"};